import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import usePriceVolumeData from "./hooks/usePriceVolumeData";
import Home from "./pages/Home";
import OrderBook from "./pages/OrderBook";
import Navigation from "./components/Navigation";
import Transactions from "./pages/Transactions";
import useOrderBookData from "./hooks/useOrderBookData";
import useOsmosisPoolData from "./hooks/useOsmosisPoolData";
import useCompletedOrdersData from "./hooks/useCompletedOrdersData";
import CommunityWallets from "./pages/CommunityWallets/CommunityWallets";
import Validators from "./pages/Validators/Validators";
import BlogHome from "./pages/Blog/BlogHome";
import Article from "./pages/Blog/components/Article";
import "uikit/dist/css/uikit.min.css";

function App() {
  const { priceVolumeData, stats } = usePriceVolumeData();
  const { buyOrders, sellOrders, midMarketPrice } = useOrderBookData();
  const osmosisPoolData = useOsmosisPoolData();
  const transactions = useCompletedOrdersData();

  return (
    <Router>
      <div className="App bg-gray-100">
        <header>
          <Navigation />
        </header>
        <main>
          <div className="app-container container mx-auto max-w-4xl">
            <Routes>
              <Route
                path="/"
                element={
                  <Home
                    priceVolumeData={priceVolumeData}
                    stats={stats}
                    osmosisPoolData={osmosisPoolData}
                    buyOrders={buyOrders}
                  />
                }
              />
              <Route
                path="/order-book"
                element={
                  <OrderBook
                    buyOrders={buyOrders}
                    sellOrders={sellOrders}
                    midMarketPrice={midMarketPrice}
                    osmosisPoolData={osmosisPoolData}
                    olswapData={stats}
                    transactions={transactions}
                  />
                }
              />
              <Route
                path="/transactions"
                element={
                  <Transactions
                    priceVolumeData={priceVolumeData}
                    sellOrders={sellOrders}
                    buyOrders={buyOrders}
                    transactions={transactions}
                  />
                }
              />
              <Route path="/community-wallets" element={<CommunityWallets />} />
              <Route path="/validators" element={<Validators />} />
              <Route path="/blog" element={<BlogHome />} />
              <Route path="/article/:slug" element={<Article />} />
            </Routes>
            <section className="text-center p-4 m-8 border-t border-gray-300">
              <h4 className="text-lg font-medium">Disclaimer</h4>
              <p className="text-sm text-gray-600">
                This site is a beta version and serves informational purposes
                only. It is not intended to incite buying or selling of any
                currency. This is not an official website of the 0L community.
                Please note that the site may contain errors.
              </p>
            </section>
          </div>
        </main>
        <footer className="footer bg-gray-100 text-center">
          <p className="mb-8">
            For donations, Slow Wallet address:
            <br />
            BEFCC99431F217F8C18263B112023B6BE77F104030E75BA6455C9B524312F316
          </p>
          <a
            href="https://forms.gle/Zfe99Ya8VZsURRZP7"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Report Issue / Request Feature
          </a>
        </footer>
      </div>
    </Router>
  );
}

export default App;
